import {MyopMessages} from "../../common/MyopMessages";
import {BaseMessageHandler} from "../../common";
import {AddEventListenerMessage, EventListenerCallbackMessage} from "../../messages";
import {makeSerializable} from "../../common/utils/serialization.ts";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

export class AddEventListenerHandler extends BaseMessageHandler<AddEventListenerMessage> {

    messageType = MyopMessages.AddEventListenerMessage;

    executor = (message: AddEventListenerMessage) => {

        const items = getElementsByRef(message.ref, document);
        const cleanupTasks: any[] = [];
        items.forEach(item => {

            const handler = (e) => {
                //TODO: think about that requestAnimationFrame
                requestAnimationFrame(() => {
                    this.messageToHost(new EventListenerCallbackMessage(message.handlerUniqueId, makeSerializable(e, message.serializableSkeleton)));
                });
            };
            item.addEventListener(message.type, handler)
            cleanupTasks.push(() => {
                item.removeEventListener(message.type, handler)
            });

        })

        return () => {
            cleanupTasks.forEach(task => {
                task();
            })
        }
    }
}
